import { IAppBreadcrumbItem } from 'components/breadcrumb/AppBreadcrumb';
import create from 'zustand';

interface ProductState {
  productDetailPreBreadcrumb: IAppBreadcrumbItem[];
  setProductDetailPreBreadcrumb: (breadcrumb: IAppBreadcrumbItem[]) => void;
}

export const useProductStore = create<ProductState>((set) => ({
  productDetailPreBreadcrumb: [],
  setProductDetailPreBreadcrumb: (payload) =>
    set(() => ({ productDetailPreBreadcrumb: payload })),
}));
